import { computed, ComputedRef } from "vue";
import { useRoute } from "vue-router/composables";

import { Team } from "@Modules/teams/Data/Models/TeamModel";
import { Organization } from  "@Modules/teams/Data/Models/OrganizationModel";
import { XTeamsStore } from  "@Modules/teams/Store/XTeamsStore";

export type UseCurrentOrganization = {
  currentOrganizationSlug: ComputedRef<string | null>;
  currentTeamSlug: ComputedRef<string | null>;
  currentOrganization: ComputedRef<Organization | null>;
  currentWorkspace: ComputedRef<Team | null>;
};

export function useCurrentOrganization(): UseCurrentOrganization {
  const route = useRoute();
  const teamsStore = XTeamsStore();

  const currentOrganizationSlug = computed(() => route.params?.org ?? null);
  const currentTeamSlug = computed(() => route.params?.team ?? null);

  const currentOrganization = computed(() => teamsStore.getOrganizationBySlug(currentOrganizationSlug.value));
  const currentWorkspace = computed(() => teamsStore.getWorkspaceBySlugAndTeam(currentOrganizationSlug.value, currentTeamSlug.value));

  return {
    currentOrganizationSlug,
    currentTeamSlug,
    currentOrganization,
    currentWorkspace,
  };
}
